import Vue from 'vue'
import ElementUI from 'element-ui'



// WEBPACK FOOTER //
// ./src/vendor.js